import { FirebaseApp } from "firebase/app";

import { AppCheck, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";







export class FirebaseAppCheck {

    _appCheck!: AppCheck;


    public constructor(app: FirebaseApp, config: any) {

        this._appCheck = initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(config.recaptchaSiteKey), // La tua Site Key pubblica
            isTokenAutoRefreshEnabled: true
        })
    }

    get appCheck() {
        return this._appCheck;
    }
}